

















































































































import AbpBase from '../../../lib/abpbase'
import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import {
	QueryStandingBookDetail, QuerySupplier, CreateStockOut,
	QueryConsumableStorageStockOut, QueryStockOutDetailById,
	QueryConsumableBatchNum, EditStockOutCheck,
	EditStockOutCharge, DeleteStockOut, QueryDepartmentByNameList
} from '../../../api/consumablesStock'
import {GetConsumables,GetUtcodeList} from '../../../api/specialDictionary'

import {GetAutCodeList} from '../../../api/basicDictionary'
import Util from '../../../lib/util'
import u from 'underscore'

//单据打印组件
import print from '../../../components/print/stockBills.vue'

@Component({
    components:{print}
})
export default class StorageOut extends AbpBase {
	//  @Watch('unitOptions')
    // WatchStaffName(val: any, oldVal: any) { 
    //    console.log(val)
    // }

    printShow:Boolean = false;
    printData = {
        list:[],
        title:[
            '单据编码',
            '耗材名称',
            '生产厂家',
            '数量',
            '单位',
            '进价',
            '进价总额',
            '零价',
            '零价总额',
            '批号',
            '科室',
            '出库人',
            '出库日期',
        ]
    }


    list = []//table数据源
	tabList:any = []//选择table数据源
	table = {
        loading:false,
        tabLoading:false,
    }
     //远程搜索加载
    remoteloading:Boolean = true;
    //点击选择or不选中
    flag:Boolean = true;

    //按钮装态
    deleteBillsShow:Boolean = false
    ztShow:Boolean = false
    checkShow:Boolean = true
    saveShow:Boolean = true

    //当前选择行状态 （暂存可新增，核对不可）
    rowStatus:Boolean = false;
    //核对loding
    checkLoding:Boolean = false;
    //暂存loding
    tsLoding:Boolean = false;
    //记账loding
    saveLoding:Boolean = false;
    //删除loding
    deleteLoding:Boolean = false;

    receiptNo:Number = Date.now();

    //数值累计判断
    reducePrice:Boolean = false;
    //当前选择行
    rowActive:any = {}

    model = {
        ConsumableId:null,
        quantity:null,
        unit:null,
        batchNo:null,
        purchasePrice:null,
        zeroPrice:null,
        deptId:null,
    }

    created() {
        // this.getConsumableList();
        // this.getMeteringList();
        this.queryDepartmentList();
        this.getTabList()
       
    }
    //选择框数据
    unitOptions=[]
    ConsumableOptions=[]
    conList=[]
    deptOptions=[]
    bathNoOptions=[]

     //获取tab 数据
    async getTabList(){
		this.table.tabLoading = true
		let payload = {
			PageSize:100,
			Page:1
		}
        let response = await QueryConsumableStorageStockOut(payload)
		this.tabList = response.data.items
        this.table.tabLoading = false
        //默认选择第一条
        if(this.tabList.length>0) {
            this.tabList[0]._highlight = true;
            this.rowActive = this.tabList[0];
            this.getStatus(this.tabList[0].stockOutStatus)
            this.getTalDetail(this.tabList[0].id)
            //单据号
            this.receiptNo = Number(this.tabList[0].receiptNo)
            //带出供货商
            this.model.deptId = this.tabList[0].deptId
            
        }else{
            this.rowActive = {}
            this.ztShow = false
            this.checkShow = true
            this.saveShow = true
            this.rowStatus = false
            this.deleteBillsShow = true
        }
    }
    getStatus(type){
        //按钮status
        if(type == 1){
            this.ztShow = false
            this.checkShow = false
            this.saveShow = true
            this.rowStatus = false
            this.deleteBillsShow = false
        }else{
            this.ztShow = true
            this.checkShow = true
            this.saveShow = false
            this.rowStatus = true
            this.deleteBillsShow = false
        }
        
    }
    //获取详情数据
    async getTalDetail(id){
        let data = {
            stockOutId:id,
            pageSize:100,
            page:1
        }
        let res  = await QueryStockOutDetailById(data)
        this.list = res.data.consumableStockOutDetailResult.items
        this.reducePrice = true;
        this.list.push({
            zj:true,
            receiptNo:'总价',
            batchPurchasePrice:res.data.sumPurchasePrice,
            batchZeroPrice:res.data.sumZeroPrice,
        })
    }

    //选择耗材信息
    ConsumableActiveinfo:any = {};
    //表格高度
    get tableHeight(){
       return window.innerHeight-580
    }
    //登陆人
    get staffName(){
        return this.$store.state.session.user?this.$store.state.session.user.name:''
    }
    //耗材
    async remoteMethodCon(query){
        let str = (this.$refs['setSelect'] as any).$data.query;
        if (str) {
        //赋值为空
            (this.$refs['setSelect'] as any).query = ''
        }
        this.ConsumableOptions = [];
		if (query !== '') {
			this.remoteloading = true;
            let data = {
                consumableName:query,
            }
            let res = await QueryConsumableBatchNum(data)
            this.conList = res.data
            setTimeout(() => {
                this.remoteloading = false;
                const list = res.data.map(item => {
                    return {
                        consumableId: item.consumableId,
                        consumableName: item.consumableName
                    };
                });
                this.ConsumableOptions = list
            }, 200);
           
        } else {
            this.ConsumableOptions = [];
        }
    }
    
	// async getConsumableList(){
    //     let res = await QueryConsumableBatchNum()
    //     console.log(res)
    //     this.ConsumableOptions = res.data
    // }
    //单位
    async getMeteringList(){
        let res = await this.$store.dispatch({
            type:'dictionaries/GetMeteringList',
        })
        this.unitOptions = res.data.items
    }
    
    //科室
    async queryDepartmentList(){
        let data = {
            typeName:'库房',
			status:1,
        }
        let res = await QueryDepartmentByNameList(data)
        this.deptOptions = res.data
        console.log(res)
    }



    //耗材信息带出
    conChange(){
       if(this.model.ConsumableId){
            this.bathNoOptions = []
            this.conList.forEach(item=>{
                if(item.consumableId==this.model.ConsumableId){
                    this.ConsumableActiveinfo = item;
                    //单位选项
                    this.unitOptions = []
                    this.unitOptions.push({
                        id:Number(item.basicUnit),
                        meterName:item.basicUnitName
                    })
                    this.model.zeroPrice = item.sellPrice
                    
                    this.model.unit = item.batchNumberArr[0].basicUnitId
                    this.model.quantity = item.batchNumberArr[0].quantity
                    this.model.purchasePrice = item.batchNumberArr[0].buyPrice
                    this.model.batchNo = item.batchNumberArr[0].batchNo

                    this.bathNoOptions = item.batchNumberArr
                }
            })
       }
    }
    //批号选择带出
    batchNoChange(){
        if(this.model.batchNo){
            this.bathNoOptions.forEach(item=>{
                if(item.batchNo==this.model.batchNo){
                    this.model.unit = item.basicUnitId
                    this.model.quantity = item.quantity
                    this.model.purchasePrice = item.buyPrice
                    this.model.batchNo = item.batchNo

                }
            })
       }
    }
    //数据导出
    exportData(){
        (this.$refs.table as any).exportCsv({
            filename: 'The original data'
        })
    }
    //清除高亮项
    clearCurrentRow(callback){
        (this.$refs.tabTable as any).clearCurrentRow()

        //重新生成单据号
        this.receiptNo = Date.now()
        //部门 置空
        this.model.deptId = 0;

        this.rowActive = {};
        this.list = []
        this.ztShow = false
        this.checkShow = true
        this.saveShow = true
        this.deleteBillsShow = true
        this.rowStatus = false
        callback()
    }
    //点击清除高亮
    firstTabChage:Boolean = true //(默认加载第一条。取消选择不会触发tabChange事件。记录没触发tabChange之前的状态)
    clecarActive(row){
        let indexs;
        this.tabList.forEach((item,index) => {
            if(item.id == row.id){
                indexs = index;
            }
        });
        if(this.rowActive.id == row.id && this.firstTabChage){
            this.clearCurrentRow(function(){})
        }
        if(this.flag){
            // this.tabList[indexs]._highlight = true;
            this.flag = false
            // this.deleteBillsShow = false;
        }else{
            this.clearCurrentRow(function(){})
            this.flag = true
        }
    }
    push(){
        let that = this;
        (this.$refs.ruleForm as any).validate(async (valid:boolean)=>{
            if(valid){
                //清空表格尾部
                if(this.reducePrice){
                    this.list.pop()
                }
                this.list.push({
                   receiptNo:this.receiptNo,
                   consumableName:this.ConsumableActiveinfo.consumableName,
                   quantity:this.model.quantity,
                   unit:this.model.unit,
                   consumableId:this.model.ConsumableId,
                   unitName: u.find(that.unitOptions, function(value, key, list){return list[key].id == that.model.unit}).meterName,
                   batchNo:this.model.batchNo,
                   purchasePrice:this.model.purchasePrice,
                   zeroPrice:this.model.zeroPrice,
                   batchPurchasePrice:this.model.purchasePrice*this.model.quantity,
                   batchZeroPrice:this.model.zeroPrice*this.model.quantity,
                   deptId:this.model.deptId,
                   manufacturer:this.ConsumableActiveinfo.manufacturer,
                   deptName: this.model.deptId?u.find(that.deptOptions, function(value, key, list){return list[key].id == that.model.deptId}).deptName:'',
                   staffName:this.staffName,
                   now:Util.dateConversion(new Date())
                })
                let values1 = this.list.map(item => Number(item.batchPurchasePrice));
                let values2 = this.list.map(item => Number(item.batchZeroPrice));
                let batchPurchasePrice = u.reduce(values1, function(memo, num){ return memo + num; }, 0);
                let batchZeroPrice = u.reduce(values2, function(memo, num){ return memo + num; }, 0);
                //合计计算
                
                this.list.push({
                    zj:true,
                    receiptNo:'总价',
                    batchPurchasePrice:batchPurchasePrice,
                    batchZeroPrice:batchZeroPrice,
                })
                this.reducePrice = true;
                this.clear();

                //清空选择项
                (this.$refs['setSelect'] as any).query = ''
                this.ConsumableOptions = [];
            }
        })
    }
    //暂存
    Ts(){
        if(this.list.length<1){
            this.$Message.info('请选择耗材');
            return false
        }
        if(!this.model.deptId){
            this.$Message.info('请选择部门');
            return false
        }
         //去掉合计
        this.list.pop()
        let data = {
            receiptNo:this.receiptNo,
            stockOutId:this.rowActive.id || 0,
            deptId:this.model.deptId,
            conStockOutInputDetailDto:this.list,
        }
        this.createStockOut(data)
    }
    async createStockOut(data){
        this.tsLoding = true;
        let res = await CreateStockOut(data)
        if(res.code==2000){
            //  
            this.list = [];
            this.receiptNo = Date.now()
            this.getTabList()
        }else{
            //  
        }
        this.tsLoding = false;
    }
    //核对
    async check(){
        let data = {
            stockOutDel:[{stockOutId:this.rowActive.id}]
        }
        this.checkLoding = true;

        let res = await EditStockOutCheck(data)
        if(res.code==2000){
             
            this.list = [];
            this.receiptNo = Date.now()
            this.getTabList()

        }else{
              
        }
        this.checkLoding = false;
    }
    //记账
    async save(){
        let data = {
            stockOutDel:[{stockOutId:this.rowActive.id}]
        }
        this.saveLoding = true;
        let res = await EditStockOutCharge(data)
        if(res.code==2000){

            this.printData.list = []
            this.list.forEach((item,index)=>{
                this.printData.list.push([
                    item.receiptNo,
                    item.consumableName,
                    item.manufacturer,
                    item.quantity,
                    item.unitName,
                    item.purchasePrice,
                    item.batchPurchasePrice,
                    item.zeroPrice,
                    item.batchZeroPrice,
                    item.batchNo,
                    item.deptName,
                    item.staffName,
                    index == this.list.length-1 ?'':Util.dateConversion(new Date()),
                ])
            })
            this.printShow = true


             
            this.list = [];
            this.receiptNo = Date.now()
            this.getTabList()
            // document.getElementById('pr').click()
        }else{
             
        }
        this.saveLoding = false;
    }
    //打印完成回调
    printBack(){
        this.printShow = false;
    }

    //删除单据
    async deleteBills(){
        this.$Modal.confirm({
			title: '确认删除',
			content: '',
			onOk: () => {
                this.deleteLoding = true;
				let data = {
                    stockOutDel:[{stockOutId:this.rowActive.id}]
                }
				this.deleteStockOut(data)
			},
			onCancel: () => {
				
			}
		})
       
        
    }
    async deleteStockOut(data:any){
        let res = await DeleteStockOut(data)
        if(res.code==2000){
             
            this.list = [];
            this.receiptNo = Date.now()
            this.getTabList()
            this.deleteLoding = false;
        }else{
             
            this.deleteLoding = false;
        }
    }
    clear(){
        (this.$refs.ruleForm as any).resetFields();
    }
    delete(index:number){
        this.list.splice(index, 1);
        if(this.list.length==1){
            this.list.splice(0, 1);
        }
    }
    //tab选择
    tabChange(currentRow:any,oldCurrentRow:any){
        // console.log(currentRow)
        this.firstTabChage = false;

        if(currentRow){
            this.rowActive = currentRow
            //带出单据号
            this.receiptNo = Number(currentRow.receiptNo)
            //带出部门
            this.model.deptId = currentRow.deptId
            this.getStatus(currentRow.stockOutStatus)
            this.getTalDetail(currentRow.id)
            if(currentRow != oldCurrentRow){
                this.flag = true
            }
        }
    }
	columns = [{
		title: '单据编码',
        key: 'receiptNo',
        width:160
	},{
		title: "耗材名称",
		key: 'consumableName',
        width:130
	},{
		title: "生产厂家",
		key: 'manufacturer',
        width:130
	},{
		title: "数量",
		key: 'quantity',
        width:130
	},{
		title: "单位",
		key: 'unitName',
        width:130
	},{
		title: "进价",
		key: 'purchasePrice',
        width:130
	},{
		title: "进价总额",
		key: 'batchPurchasePrice',
        width:130
	},{
		title: "零价",
		key: 'zeroPrice',
        width:130
	},{
		title: "零价总额",
		key: 'batchZeroPrice',
        width:130
	},{
		title: "批号",
		key: 'batchNo',
        width:130
	},{
		title: "科室",
		key: 'deptName',
        width:130
	},{
		title: "出库人",
		key: 'staffName',
        width:130
	},{
		title: "出库日期",
		key: 'now',
        width:130,
        render: (h: any, params: any) => {
           if(params.row.now){
               return h('span',Util.formatTime(params.row.now))
           }else{
               return h('span',Util.formatTime(params.row.creationTime))
           }
        }
	},{title: this.L('Actions'),
        key: 'Actions',
        width:80,
        fixed: "right",
		render: (h: any, params: any) => {
			if(!params.row.zj){
                return h('div', [
                    h('Button', {
                        props: {
                            type: 'error',
                            size: 'small'
                        },
                        on: {
                            click: () => {
                                this.delete(params.add)
                            }
                        }
                    }, this.L('Delete'))
                ])
            }
		}
   
    }]
    tabColumns=[{
		title: '单据编码',
        key: 'receiptNo',
	},{
		title: "入库日期",
        key: 'stockOutDate',

	},{
		title: "操作员",
        key: 'staffName',
	},{
		title: "状态",
        key: 'stockOutStatus',
        render:(h: any, params: any) => {
            return h('span',params.row.stockOutStatus == 1?"暂存":"核对")
        }   
	}]
    rules={
        ConsumableId:[{required: true,message:this.L('FieldIsRequired'),type:'number',trigger: 'blur'}],
        unit:[{required:true,message:this.L('FieldIsRequired'),type:'number',trigger: 'blur'}],
        deptId:[{required:true,message:this.L('FieldIsRequired'),type:'number',trigger: 'blur'}],
        batchNo:[{required: true,message:this.L('FieldIsRequired'),trigger: 'blur'}],
        quantity:[{required: true,message:this.L('FieldIsRequired'),type:'number', trigger: 'blur'}],
        validityPeriod:[{required: true,message:this.L('FieldIsRequired'),type:'date',trigger: 'blur'}],
        purchasePrice:[ { required: true, message:this.L('FieldIsRequired'),type:'number',trigger: 'blur'}],
        zeroPrice:[ { required: true, message:this.L('FieldIsRequired'),type:'number',trigger: 'blur'}],
        supplierId:[ { required: true, message:this.L('FieldIsRequired'),type:'number',trigger: 'blur'}],
        receiptNo:[ { required: false, message:this.L('FieldIsRequired'),trigger: 'blur'}],

    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/consumablesStock/storageOut/index.vue